(function() {
    'use strict'

    angular
        .module('wf.common')
        .component('wfItemWfid', {
            template: '<div ng-if="::$ctrl.wfcid" class="itemWfid">{{::$ctrl.wfcid}}</div>',
            controller: wfItemWfidController,
            bindings: {
                wfcid: '<',
            },
        })

    wfItemWfidController.$inject = []
    function wfItemWfidController() {}
})()
